<template>
    <div v-if="data" class="w-full flex flex-column mb-2 xl:mb-3 lg:mb-3 md:mb-3">
        <div class="w-full flex flex-column xl:flex-row lg:flex-row md:flex-row pr-0 xl:pr-0 lg:pr-0 md:pr-0">
            <div class="w-full flex flex-column surface-50 xl:flex-row lg:flex-row md:flex-row
                p-3 xl:p-4 lg:p-4 md:p-4
                border-round-lg xl:border-round-2xl lg:border-round-2xl md:border-round-xl
                text-left">
                <div class="flex flex-column flex-1 mb-3">
                    <span class="flex text-600 mb-2 text-sm">
                        Баланс:
                    </span>
                    <span v-if="data && data.wallet" class="flex text-700 text-2xl font-medium white-space-nowrap">
                        <span v-if="data.wallet.balance">{{ get_format_amount(data.wallet.balance, data.wallet.currency) }}</span><br>
                    </span>
                    <div v-else>
                        <span>нет кошелька</span><br>
                        <Button label="Создать кошель" @click="create_wallet()" :loading="loading" class="mt-2"/>
                    </div>
                    <div v-if="data && data.wallet" class="flex flex-row gap-2">
                        <Button v-if="is_admin && isUserInGroup('admin')" label="Пополнить" @click="displayTopup = true" class="mt-2" size="small" :disabled="loading || !data" icon="pi pi-arrow-down" iconPos="right"/>
                        <Button v-if="is_admin && isUserInGroup('admin')" label="Списать" @click="displayWithdraw = true" class="mt-2 bg-orange-500 border-orange-500 text-white" size="small" :disabled="loading || !data" icon="pi pi-arrow-up" iconPos="right"/>
                    </div>
                </div>
                <div v-if="is_admin && isUserInGroup('admin')" class="flex flex-column flex-1 mb-3">
                    <span class="flex text-600 mb-2 text-sm">
                        Депозит:
                    </span>
                    <span v-if="data && data.deposit" class="flex text-700 text-2xl font-medium white-space-nowrap">
                        <span v-if="data.deposit">{{ get_format_amount(data.deposit, 'usdt') }}</span><br>
                    </span>
                </div>
                <div v-if="is_admin && isUserInGroup('admin')" class="flex flex-column">
                    
                    <div v-if="data && data.wallet">

                        <span class="text-sm flex flex-row" @click="copy(data.wallet.id)">
                            <span class="flex text-600 mb-2 text-sm mr-2">ID:</span>
                            <span class="flex">{{get_short_id(data.wallet.id)}}</span>
                            <span class="flex pi pi-copy ml-2 text-500 text-xs cursor-pointer"></span>
                        </span>

                        <div class="flex flex-row gap-2">
                            <Button v-if="isUserInGroup('admin')" label="Кошелек" @click="detail_page(data.wallet.id, 'wallet', false)" 
                                class="mt-2" size="small"/>
                            
                            <Button v-if="isUserInGroup('admin')" @click="detail_page(data.wallet.id, 'wallet', true)" 
                                class="mt-2" size="small" icon="pi pi-external-link" iconPos="right"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--ПОПОЛНЕНИЕ-->
        <Dialog header="Пополнить" class="flex flex-column border-none" modal v-if="is_admin && isUserInGroup('admin')"
            v-model:visible="displayTopup" :breakpoints="{'960px': '75vw', '640px': '90vw'}" :style="{width: '30vw'}" >
            <div class="w-full mb-3">
                <span class="flex text-600 mb-2 text-sm">
                    Сумма:
                </span>
                <InputGroup> 
                    <InputNumber v-model="topupAmount" :min="0.0000001" :max="100000000" :maxFractionDigits="6" size="large"
                        class="w-full border-2 surface-border border-round-xl border-noround-right overflow-hidden border-right-none pl-2" />
                    <InputGroupAddon class="border-2 border-left-none border-round-xl border-noround-left">
                        <i class="pi pi-clipboard p-1 surface-0 border-circle cursor-pointer" @click="put()" />
                    </InputGroupAddon>
                </InputGroup>
            </div>

            <div class="w-full mb-3">
                <span class="flex text-600 mb-2 text-sm">
                    Описание:
                </span>
                <Textarea rows="5" cols="20" class="w-full surface-border border-2 border-round-lg text-sm p-2 mt-2 mb-3" 
                    :value="topupDescription"
                    @input="topupDescription = $event.target.value"
                    style="resize: none !important; font-family: inherit;"
                    />
            </div>

            <template #footer>
                <Button label="Пополнить" @click='topup()' :disabled="!data || loading" :loading="loading"/>
            </template>
        </Dialog>

        <!--СПИСАНИЕ-->
        <Dialog header="Списать" class="flex flex-column" modal v-if="is_admin && isUserInGroup('admin')"
            v-model:visible="displayWithdraw" :breakpoints="{'960px': '75vw', '640px': '90vw'}" :style="{width: '30vw'}" >
            <div class="w-full mb-3">
                <span class="flex text-600 mb-2 text-sm">
                    Сумма:
                </span>
                <InputGroup>
                    <InputNumber v-model="withdrawAmount" :min="0.0000001" :max="100000000" :maxFractionDigits="6" size="large"
                        class="w-full border-2 surface-border border-round-xl border-noround-right overflow-hidden border-right-none pl-2" />
                    <InputGroupAddon class="border-2 border-left-none border-round-xl border-noround-left">
                        <i class="pi pi-clipboard p-1 surface-0 border-circle cursor-pointer" @click="put()" />
                    </InputGroupAddon>
                </InputGroup>
            </div>

            <div class="w-full mb-3">
                <span class="flex text-600 mb-2 text-sm">
                    Описание:
                </span>
                <Textarea rows="5" cols="20" class="w-full surface-border border-2 border-round-lg text-sm p-2 mt-2 mb-3" 
                    :value="withdrawDescription"
                    @input="withdrawDescription = $event.target.value"
                    style="resize: none !important; font-family: inherit;"
                    />
            </div>

            <template #footer>
                <Button label="Списать" @click='withdraw()' :disabled="!data || loading" :loading="loading" class="bg-orange-500 border-orange-500 text-white"/>
            </template>
        </Dialog>
    </div>
    <Skeleton v-else height="3rem" class="border-round-lg"/>
</template>

<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'

export default {
    props: ['data', 'merchant_id', 'is_admin'],
    data() {
        return {
            loading: false,
            displayTopup: false,
            topupAmount: 1,
            topupDescription: '',
            displayWithdraw: false,
            withdrawAmount: 1,
            withdrawDescription: '',
        }
    },
    methods: {
        isUserInGroup: function (type) { 
            return this.helper.isUserInGroup(type, this.$store.getters.StateGroups)
        },
        get_format_amount(value, currency) {
            return this.helper.format_amount(value, currency)
        },
        get_short_id(value){
            if(!value) return ''
            return this.helper.get_short_id(value)
        },
        copy(text){
            this.helper.copy_clipboard(text)
            this.$toast.add({ severity: 'info', summary: 'Скопировано', detail: text, life: 1000 })
        },
        async getClipboardData() {
            try {
                const text = await navigator.clipboard.readText();
                return text;
            } catch (err) {
                console.error('Failed to read clipboard contents:', err);
                return null;
            }
        },
        put() {
            this.getClipboardData().then(data=>{
                if(data && !isNaN(data) && data>0) {
                    if(this.displayTopup) this.topupAmount = parseFloat(data)
                    if(this.displayWithdraw) this.withdrawAmount = parseFloat(data)
                }
            })
        },
        detail_page(id, type='wallet', new_tab = false) {
            if(new_tab){
                const routeData = this.$router.resolve({path: '/admin/'+type+'/' + id});
                window.open(routeData.href, '_blank');
            } else  this.$router.push({ path: '/admin/'+type+'/' + id })
        },
        async create_wallet(){
            this.loading = true
            const data = {
                merchant_id: this.merchant_id
            } 
            const res = await this.connect.create_wallet_mr(data).then(res=>res)
            if(res.result){
                this.data.wallet = res.data
                this.$toast.add({ severity: 'success', summary: 'Успешно', detail: 'Кошелек создан', life: 2000 })
            } else {
                this.$toast.add({ severity: 'error', summary: 'Ошибка', detail: res.errors[0], life: 2000 })
            }
            this.loading = false
        },
        async topup(){
            this.loading = true
            const data = {
                id: this.merchant_id,
                amount: this.topupAmount,
                description: this.topupDescription
            }
            this.connect.AddBalanceToMerchantByAdmin(data).then(res=>{
                if(res.result){
                    this.$toast.add({ severity: 'success', summary: 'Успешно', detail: 'Пополнение прошло успешно', life: 2000 })
                    this.displayTopup = false
                    this.topupAmount = 0
                } else {
                    if(res.errors && res.errors.length) this.$toast.add({ severity: 'error', summary: 'Ошибка', detail: res.errors[0], life: 2000 })
                    else this.$toast.add({ severity: 'error', summary: 'Ошибка', detail: 'Ошибка сервера', life: 2000 })
                }
                this.loading = false
            })
        },
        async withdraw(){
            this.loading = true
            const data = {
                id: this.merchant_id,
                amount: this.withdrawAmount,
                description: this.withdrawDescription
            }
            this.connect.WithdrawBalanceFromMerchantByAdmin(data).then(res=>{
                if(res.result){
                    this.$toast.add({ severity: 'success', summary: 'Успешно', detail: 'Списание прошло успешно', life: 2000 })
                    this.displayWithdraw = false
                    this.withdrawAmount = 0
                } else {
                    if(res.errors && res.errors.length) this.$toast.add({ severity: 'error', summary: 'Ошибка', detail: res.errors[0], life: 2000 })
                    else this.$toast.add({ severity: 'error', summary: 'Ошибка', detail: 'Ошибка сервера', life: 2000 })
                }
                this.loading = false
            })
        },
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },
}
</script>